module.exports = __webpack_public_path__ + "fonts/fa-solid-900.fb8184a.woff2";